$(document).ready(function () {
    var mySwiper = new Swiper ('.swiper-containermes', {
    direction: 'vertical',
    effect: 'slide',
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 2000,
        reverseDirection: true,
        disableOnInteraction: false,
    },
});

  $('.megamenu_parent .mega-menu__list .submenu_list_head a').hover(function () {
    $('.megamenu_parent .mega-menu__list .submenu_list_head a').removeClass('active');
    $(this).addClass('active');
    var clickedMenuTitle = $(this).parent('.submenu_list_head').attr("data_title");
    if(clickedMenuTitle == "humidors"){
       $(".sub_menu_list_and_image_container").hide() ;
      $(".sub_menu_list_and_image_container").each(function (index,elem) {
          if( $(elem).attr('data-title') == 'humidors' ){
            $(elem).show() ;
          }
      });
    }
    else{
      $('.sub_menu_list_and_image_container').show();
      $(".sub_menu_list_and_image_container").each(function (index,elem) {
            if( $(elem).attr('data-title') == 'humidors' ){
              $(elem).hide() ;
            }
      });
      $('.sub_menu_list .submenu_list_head').hide();
      $('.sub_menu_list .submenu_list_head').each(function () {
        var subMenuToBeOpen = $(this).attr("data_title") ; 
        // console.log(subMenuToBeOpen) ;

        if( clickedMenuTitle == subMenuToBeOpen  ){
          // console.log("yes");
          $(this).css("display","flex");
        }
      })

    var grandMenuList = $('.sub_menu_list .mega-menu__list .submenu_list_head').each(function(index,element){
      var firstListItem = $(element).children().find(".grandchild_menu_list").eq(0).attr('data_title') ;
       if( clickedMenuTitle == $(element).attr('data_title')){
        $('.image_content_container .menu_desc_and_image').hide() ;
         $('.image_content_container .menu_desc_and_image').each(function (index , elem){
           // console.log($(elem).attr('data-collection-content')) ;
              if( firstListItem == $(elem).attr('data-collection-content') ){
                $(elem).css("display","flex");
              }
         }) ;
      }
      });
    }
  }, function(){});
  $('.sub_menu_list .mega-menu__list .submenu_list_head .grandchild_menu .grandchild_menu_list a').hover(function () {
      var hoveredSubMenuListTitle = $(this).parent('.grandchild_menu_list').attr("data_title") ;
       $('.image_content_container .menu_desc_and_image').hide();
      $('.image_content_container .menu_desc_and_image').each(function (index , element) {
          if(hoveredSubMenuListTitle == $(element).attr("data-collection-content") ){
            $(element).css("display","flex");
          }
      })
  })
});



$( document ).ready(function() {
// js for custom collection list slider
 var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    slidesPerGroupSkip: 1,
    cssMode: true,
    mousewheel: true,
    keyboard: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
   breakpoints: {
      1199: {
        slidesPerView: 4.2,
        slidesPerGroup: 1,
      },
     991: {
        slidesPerView: 3.2,
        slidesPerGroup: 1,
      },
     767: {
        slidesPerView: 2.2,
        slidesPerGroup: 1,
      },
     480: {
        slidesPerView: 2,
        slidesPerGroup: 1,
      },
    },
  });

  // js for product slider in small devices
   var swiper = new Swiper(".mySwiperMobile", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
     breakpoints: {
     540: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        },
      },
    });

  // js for itg colloction list slider
  var swiper = new Swiper(".mySwiperCollection", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
     breakpoints: {
     750: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        },
      },
    });
  
  // js for footer menu as accordion
   $(document).on('click', '.footer-block--menu .footer-block__heading', function () {
      $(this).toggleClass('open');
  });
  $('.footer-block--menu .footer-block__heading').append('<span class="plus_icon">+</span><span class="minus_icon">-</span>');

//   /* product image js start */
    $(document).on('click', '.custom_label_var', function() {
      $('.custom_input_var').removeAttr('checked', 'checked');
      $(this).prev('.custom_input_var').attr('checked', 'checked');
    });
    $(document).on('click', '.dimension_label_var', function() {
      $('.dimension_input_var').removeAttr('checked', 'checked');
      $(this).prev('.dimension_input_var').attr('checked', 'checked');
    });


  
/* variant metafeild js start */
    updateMetafieldVariantImage();  
    $(document).on('click', '.product-form__input--pill input', function() {
      updateMetafieldVariantImage();
    }); 
    
    function updateMetafieldVariantImage() {
      var varselectedValue = $('.product-form__input--pill input:checked').attr('data-option');
      $(document).find('.dimensions_img_grid').hide();
      $(document).find('.dimensions_img_grid[data-var-name="'+varselectedValue+'"]').show();
    }
  // js for mobile view
  // updateMetafieldVariantImageDimen();
  $(document).on('click', '.dimensions_variants input', function() {
    updateMetafieldVariantImageDimen();
  }); 
  
  function updateMetafieldVariantImageDimen() {
   var VarselectedValue = $('.dimensions_variants input:checked').attr('data-option');
   var NewVarselectedValue = VarselectedValue.toLowerCase().replace(/ /g, '-');

    $(document).find('.dimensions_img_grid').hide();
      $(document).find('.dimensions_img_grid[data-var-name="'+VarselectedValue+'"]').show();
  }
/* variant metafeild js end */  
  
  // js for read more/less product description
   $('.readmore').click(function () {
    var $productDescription = $(this).parents('.product_desc_slider').find('.swiper-slide.swiper-slide-active .product_description_lg');
    $productDescription.css('overflow', 'auto');
    $productDescription.scrollTop(320); // Reset scroll position to top
    $('.readmore').css('display', 'none');
    $('.readless').css('display', 'block');
  });
  
  $('.readless,.product_description .slider_foot_navs .swiper-button-next, .product_description .slider_foot_navs .swiper-button-prev').click(function () {
    var $productDescription = $(this).parents('.product_desc_slider').find('.swiper-slide.swiper-slide-active .product_description_lg');
    $productDescription.css('overflow', 'hidden');
    $productDescription.scrollTop(0); // Reset scroll position to top
    $('.readmore').css('display', 'block');
    $('.readless').css('display', 'none');
  });


 // js for collection banner slider
  var swiper = new Swiper(".Collection_banner_slider", {
      slidesPerView: 1,
      spaceBetween: 10,
      keyboard: true,
      // centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 50,
          loop:false,
        },
      },
    });
// js for the collection page end
});

// js for home page product slider
 function reloadSwiper(){
     var swiper = new Swiper(".mySwiperMobile", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      dots: false,
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
     breakpoints: {
     540: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        },
      },
    });
    const slider = document.getElementById('swiper_slider');
    const grids = slider ? slider.getElementsByClassName('slide_grid'): null;
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');

     if (!slider || !grids.length || !prevBtn || !nextBtn) {
        console.log('This In Not Slider Page.');
        return;
    }
    
    let activeIndex = 0;
    let offsetVar = 28;
    const gridCount = grids.length;
    let ProgressPercent = 0;
    let InitialProgressPercent = 100/gridCount;
    document.querySelector('#ScrollBar .filled').style.width = `${InitialProgressPercent}%`;
    function updateActiveGrid(newIndex) {
        grids[activeIndex].classList.remove('active');
        grids[newIndex].classList.add('active');
        activeIndex = newIndex;
        if (activeIndex >= 3) {
            let offset = (-offsetVar * (activeIndex - 2)) + (offsetVar/2) ; // Adjust the slider position
            slider.style.transform = `translateX(${offset}%)`;
        } else {
            slider.style.transform = 'translateX(0)';
        }
    }
    nextBtn.addEventListener('click', () => {
        const newIndex = (activeIndex + 1) % gridCount;
        updateActiveGrid(newIndex);
        setProgressBar(activeIndex)
    });

    prevBtn.addEventListener('click', () => {
        const newIndex = (activeIndex - 1 + gridCount) % gridCount;
        updateActiveGrid(newIndex);
        setProgressBar(activeIndex)
    });

    function setProgressBar(activeIndex) {
        ProgressPercent = InitialProgressPercent * activeIndex
        document.querySelector('#ScrollBar .filled').style.setProperty('left',`${ProgressPercent}%`);
    } 
    
    setProgressBar(activeIndex)
    updateActiveGrid(0); // Initialize the first active grid
    }
  reloadSwiper();
  document.addEventListener('DOMContentLoaded', () => {
   reloadSwiper();
     var swiper = new Swiper(".product_desc_slider", {
      slidesPerView: 1,
      autoHeight: true,
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
      // js for fixed add to bag bar
    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();
      if (scroll >= 500) {$(".fixed_content_wrapper").addClass("Show_Bar");} else {$(".fixed_content_wrapper").removeClass("Show_Bar");}
    });
    var selectors = {
      productVideos: '[data-product-videos]',
    };
    var prodVideos = $(selectors.productVideos).find('.product-videos__item');
    if (prodVideos.length > 1) {
      $(selectors.productVideos).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: false,
      });
    }

    prodVideos.on('click', function() {
      var vid_id = $(this).attr('data-video-id');
      $(this).html('<div class="intrinsic-container intrinsic-container-16x9"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + vid_id + '/?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>');
    });
});


// New custom js
// for shop by need page
  document.addEventListener('DOMContentLoaded', function () {
  if( document.querySelectorAll('.product-single__downloads-list  a').length >= 1){
      //document.querySelector('.product-single__downloads-list a').text = 'View Product Manual';
  }
  var MainMenuButton = document.querySelectorAll('.indoor_menu li button');
    MainMenuButton.forEach(function(button) {
      button.addEventListener('click', function() {
        MainMenuButton.forEach(function(buttonRemove) {
            buttonRemove.classList.remove('active');
        });
        button.classList.add('active');
        var handleValue = button.getAttribute('data-handle');
        var hiddenLists = document.querySelectorAll('.hidden_list,.main_selected_image img');
        hiddenLists.forEach(function(hiddenList) {
            hiddenList.style.display = 'none';
        });
        var targetHiddenList = document.querySelector(`.hidden_list[data="${handleValue}"]`);
         var selectedImage = document.querySelector(`.main_selected_image img.inner_image_div[imagecolhandle="${handleValue}"]`);
            if (selectedImage) {
                selectedImage.style.display = 'block';
            }
        if (targetHiddenList) {
            targetHiddenList.style.display = 'block'; 
            var productImageElement = targetHiddenList.querySelector('li.active').getAttribute('data_productimg');
            var collectionHandle = targetHiddenList.querySelector('li.active').getAttribute('LinkHandle');
            var collectionTitle =  targetHiddenList.querySelector('li.active').getAttribute('LinkTitle');
            var selectedDetails = targetHiddenList.querySelector('li.active .categorys_title_width_desc').innerHTML;
            document.querySelector('.collection_image img').setAttribute('src', `${productImageElement}`);
            document.querySelector('.collection_image img').style.display="block";
            document.querySelector('.categorys_data_right .categorys_title_width_desc').innerHTML = selectedDetails
            document.querySelector('.shopByNeedCollectiomList h2.section_title span').innerHTML = `POPULAR ${collectionTitle}`;
        }
      filterProduct(collectionHandle)
    });
  });
  var innerMenuButton = document.querySelectorAll('.hidden_list li');
  innerMenuButton.forEach(function(innrButton) {
    innrButton.addEventListener('click', function() {
      innerMenuButton.forEach(function(buttonRemove) {
         var siblings = Array.from(innrButton.parentElement.children);
          siblings.forEach(function(sibling) {
            sibling.classList.remove('active');
        });
      }); 
       innrButton.classList.add('active');
       var productImageElement = innrButton.getAttribute('data_productimg');
       var collectionHandle = innrButton.getAttribute('LinkHandle');
       var collectionTitle = innrButton.getAttribute('LinkTitle');
       var selectedDetails = innrButton.querySelector('.categorys_title_width_desc').innerHTML; 
       document.querySelector('.collection_image img').setAttribute('src', `${productImageElement}`);
       document.querySelector('.collection_image img').style.display="block";
       document.querySelector('.categorys_data_right .categorys_title_width_desc').innerHTML = selectedDetails;
       document.querySelector('.shopByNeedCollectiomList h2.section_title span').innerHTML = `POPULAR ${collectionTitle}`;
       filterProduct(collectionHandle)
    }); 
  });
  function filterProduct(collection) {
  var url = collection +'/?section_id=custom-featured-collection';
  fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(responseText => {
      var parser = new DOMParser();
      var responseDocument = parser.parseFromString(responseText, 'text/html');
      var sliderElement = responseDocument.querySelector('.CustomFeaturedHidden').innerHTML;
      document.querySelector('.ITGShopSliderdata').innerHTML = sliderElement;
      reloadSwiper();
    });
  }

});
  //shop by Need page filter
  var ShopByNeedFilter = document.querySelectorAll('.ShopByNeedFilter');
    ShopByNeedFilter.forEach(function(innrButton) {
      innrButton.addEventListener('click', function(event) {
        event.preventDefault();
        var collectionHandle = innrButton.getAttribute('href');
        shopNeedFilter(collectionHandle)
      });
  });

  function shopNeedFilter(collection) {
  var url = collection;
  fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(responseText => {
      var parser = new DOMParser();
      var responseDocument = parser.parseFromString(responseText, 'text/html');
      var sliderElement = responseDocument.querySelector('#AjaxinateLoop').innerHTML;
      var FilterTitle =  responseDocument.querySelector('#AjaxinateLoop').getAttribute('data-Title');
      var FilterProductCount =  responseDocument.querySelector('#AjaxinateLoop').getAttribute('productCount');
      if (responseDocument.querySelectorAll('#AjaxinatePagination a').length) {
        var PaginationLink = responseDocument.querySelector('#AjaxinatePagination a').getAttribute('href');
        document.querySelector('#AjaxinatePagination a').setAttribute('href', PaginationLink);
         document.querySelector('#AjaxinatePagination a').style.display ='inline-block';
      }else{
         document.querySelector('#AjaxinatePagination a').style.display ='none';
      }
      document.querySelector('#AjaxinateLoop').innerHTML = '';
      document.querySelector('#AjaxinateLoop').innerHTML = sliderElement;
     
      document.querySelector('.FilterTab_Wrap h3').innerHTML = `RECOMMENDED ${FilterTitle}`;
      document.querySelector('.product_countedbox .product_counted').innerHTML = FilterProductCount;
     })
    .catch(error => {
      console.error('Fetch error:', error);
    });
  }
// Shop By Need Filter End  
  window.onload=function(){
    if( document.querySelectorAll('.product-single__downloads-list  a').length >= 1){
        document.querySelector('.product-single__downloads-list a').inneHTML = 'View Product Manual';
        document.querySelector('.product-single__downloads-list a').classList.add('active');
    }
    if( document.querySelectorAll('.indoor_menu li .collection-link.active').length >= 1){
        document.querySelector('.indoor_menu li .collection-link.active').click();
    }
  };
$(document).on('dblclick','.ItgredirectdblCLick ',function name(params) {
  var linkredirect = $(this).attr('datahref');
  window.location.href= linkredirect;
});
$(document).ready(function() {
  var windowUrl = window.location.pathname;
  var splitUrl_1 = windowUrl.split('/')[1];
  var splitUrl_2 = windowUrl.split('/')[2];
  var splitUrl_3 = windowUrl.split('/')[3];
  if ($('.pt-filter-drawer .filter-clear').length && splitUrl_3 != undefined) {
    setTimeout(function() {
      requestAnimationFrame(function() {
        $('html, body').animate({ 
          scrollTop: $('.FilterTab_Sec').offset().top 
        }, 500);
      });
    }, 500);
  }

});



// LUMA JS

$(document).ready(function() {

  // WEBSITE TAB
  $(document).on('click','.website_tab',function () {
    let WebHasNewair = $(this).hasClass('newair_logo');
    let WebHasLuma = $(this).hasClass('luma_logo');
    if(WebHasNewair){
      localStorage.setItem('Website','Newair');
      // alert('WebHasNewair')
    }
    else if (WebHasLuma){
      localStorage.setItem('Website','Luma');
      // alert('WebHasLuma')
    }
  });
  
  let WesbiteName = localStorage.getItem('Website');
 
   if($('body').hasClass('template_index')) {
        localStorage.setItem('Website','Newair');
        WesbiteName = localStorage.getItem('Website');
        if (WesbiteName == "Newair"){
          $('body').addClass('website_newair')
           $('.newair_logo').addClass('logo_active').siblings().removeClass('logo_active')
        }
    }
    else if($('body').hasClass('template_luma-contact')) {
        localStorage.setItem('Website','Luma');
        WesbiteName = localStorage.getItem('Website');
        if (WesbiteName == "Luma"){
          $('body').addClass('website_luma')
           $('.newair_logo').addClass('logo_active').siblings().removeClass('logo_active')
        }
    }
    else if($('body').hasClass('template_luma')) {
        localStorage.setItem('Website','Luma');
        WesbiteName = localStorage.getItem('Website');
        if (WesbiteName == "Luma"){
          $('body').addClass('website_luma')
           $('.newair_logo').addClass('logo_active').siblings().removeClass('logo_active')
        }
    }
    if (WesbiteName == "Newair"){
      $('body').addClass('website_newair')
      $('.newair_logo').addClass('logo_active').siblings().removeClass('logo_active')
    }else if(WesbiteName == "Luma"){
     $('body').addClass('website_luma')
      $('.luma_logo').addClass('logo_active').siblings().removeClass('logo_active')
    }


    let LumaProduct = $('body').hasClass('products_belongs_to_luma');
    let NewairProduct = $('body').hasClass('products_belongs_to_newair');
    if(LumaProduct){
      $('body').addClass('website_luma').removeClass('website_newair');
      $('.luma_logo').addClass('logo_active').siblings().removeClass('logo_active');
    }
    else if(NewairProduct) {
      $('body').addClass('website_newair').removeClass('website_luma');
      $('.newair_logo').addClass('logo_active').siblings().removeClass('logo_active');
    }


      // VARIANT AND THUB
  if($('.main_product_page').hasClass('product_have_default_variant')){
    $(document).on('click', '#variant_button_value' , function() {
      let DataVariant = $(this).attr('data-variant-data');
      $('.thumbnail-list__item').each(function () {
        let DataImgAlt = $(this).attr('data-img-alt');
        if(DataImgAlt){
          if(DataVariant == DataImgAlt){
            $(this).show();
          }
          else{
            $(this).hide();
          }
        }
      });
    });
  
    $(document).on('click', '#variant_button_value' , function() {
      let DataVariant = $(this).attr('data-variant-data');
      $('.dimensions_img_grid').each(function () {
        let DataImgAlt = $(this).attr('data-var-name');
        if(DataVariant == DataImgAlt){
          $(this).show();
        }
        else{
          $(this).hide();
        }
      });
    });
  
    let DataVariant = $('#variant_button_value').attr('data-variant-data');
    $('.thumbnail-list__item').each(function () {
      let DataImgAlt = $(this).attr('data-img-alt');
      if(DataImgAlt){
        if(DataVariant == DataImgAlt){
          $(this).show();
        }
        else{
          $(this).hide();
        }
      }
    });
  }

$(".affirm-as-low-as").hide();
 
});

